'use client';

import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Modal } from '@mantine/core';
import { useStore } from '@/stores';
import { PostForm } from '../Posts/PostForm/PostForm';

export const CreatePostModal = observer(() => {
  const store = useStore();
  const { t } = useTranslation();
  // const canCreatePostAi = useFlag(Flags.CreatePostModal);

  useEffect(() => {
    if (!store.createPostModal.opened) {
      store.createPostModal.reset();
    }
  }, [store.createPostModal, store.createPostModal.opened]);

  if (!store.createPostModal.opened) {
    return null;
  }

  return (
    <Modal
      opened={store.createPostModal.opened}
      onClose={store.createPostModal.close}
      size="xl"
      title={t('post.create')}
    >
      <PostForm
        clientId={store.createPostModal.clientId}
        key={store.createPostModal.postVersion}
        initialDate={store.createPostModal.date}
        initialTitle={store.createPostModal.post?.theme}
        initialContent={store.createPostModal.post?.content}
        initialDocumentation={`${store.createPostModal.post?.visualInstructions ?? ''}\n\n${store.createPostModal.post?.goal ?? ''}`}
      />
    </Modal>
  );
});
